import { Injectable } from '@angular/core';
import { IAuthenticator, AuthType } from '@ext-interfaces/authenticator.model';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public isAuthenticating = false;

    constructor(private authenticator: IAuthenticator) {
        this.isAuthenticating = authenticator.isAuthenticating;
    }

    public authenicateGoogleUser(): void {
        this.authenticator.authenicateGoogleUser();
    }
    public authenicateMicrosoftUser(authType: AuthType, data?: { email: string; password?: string }): void {
        this.authenticator.authenicateMicrosoftUser(authType, data);
    }
}
